import React, { forwardRef } from "react";
import { bool, node, oneOf, string } from "prop-types";

import componentSizes from "../../../../constants/componentSizes";
import * as S from "./styled";

export const SelectInput = forwardRef(
  ({ children, disabled, isValid, size, ...props }, ref) => (
    <S.Select
      ref={ref}
      disabled={disabled}
      isValid={isValid}
      size={size}
      {...props}
    >
      {children}
    </S.Select>
  )
);

SelectInput.propTypes = {
  children: node.isRequired,
  disabled: bool,
  isValid: bool,
  size: oneOf([componentSizes.SM, componentSizes.MD, componentSizes.LG])
};

SelectInput.defaultProps = {
  disabled: false,
  isValid: true,
  size: componentSizes.MD
};

SelectInput.displayName = "SelectInput";

export const Option = ({ children, value, ...props }) => (
  <option {...props} value={value}>
    {children}
  </option>
);

Option.propTypes = {
  children: node.isRequired,
  value: string.isRequired
};

export const OptGroup = ({ children, ...props }) => (
  <optgroup {...props}>{children}</optgroup>
);

OptGroup.propTypes = {
  children: node.isRequired
};
